import { type GraphQLSingularResponse } from 'relay-runtime';

import { fg } from '@atlaskit/platform-feature-flags';

export const getTraceIdFromExtensions = ({
	extensions,
}: GraphQLSingularResponse): string | undefined => {
	if (extensions === undefined || extensions.gateway === undefined || extensions.gateway === null) {
		return undefined;
	}

	if (fg('platform_relay_fetch_use_tid_property')) {
		if (typeof extensions.gateway.tId === 'string') {
			// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
			return extensions.gateway.tId as string;
		}
	} else {
		if (typeof extensions.gateway.trace_id === 'string') {
			// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
			return extensions.gateway.trace_id as string;
		}
	}

	return undefined;
};
